import { GetBondsSameIssuerParams } from '@goldwasserexchange/actor/rest-services';
import { createContext } from 'react';

export const securityBondSameIssuerParamsContext = createContext<Partial<GetBondsSameIssuerParams>>({});
